export default __webpack_public_path__ + "static/media/QuarterPipe_02.256.19fa0a58.png";